import React, { useMemo } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { useSelector } from 'react-redux';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { withLanguage } from '../common/Texts';
import LabeledField from './LabeledField';

// Labeled password field with a show/hide toggle. Visibility is controlled by
// the parent (show / onToggleShow) so several fields can share a single toggle.
export default function PasswordField({ id, label, value, onChange, show, onToggleShow, ...textFieldProps }) {
    const language = useSelector((state) => state.user.language);
    const t = useMemo(() => withLanguage(language), [language]);
    const toggleLabel = show ? t('hide_password') : t('show_password');

    return (
        <LabeledField
            id={id}
            label={label}
            value={value}
            onChange={onChange}
            type={show ? 'text' : 'password'}
            {...textFieldProps}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small" edge="end"
                                onClick={onToggleShow}
                                aria-label={toggleLabel}
                            >
                                {show
                                    ? <VisibilityOffIcon fontSize="small" />
                                    : <VisibilityIcon fontSize="small" />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
}
